<div class="modal-header">
  <h5 class="modal-title">{{ title }}</h5>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="close()"></button>
</div>

<div class="modal-body">
  <p class="mb-0 lh-base" [innerHTML]="message"></p>
</div>

@if (showCloseButton) {
  <div class="modal-footer d-flex justify-content-end gap-2">
    <button type="button" class="btn btn-primary" (click)="close()">
      Chiudi
    </button>
  </div>
}

